<script setup>
import eventBus from '@/eventBus';
import { useShopify } from '@/stores/shopify';
import ButtonDefault from '@/components/atoms/ButtonDefault.vue';
import ProductQuantityChanger from './ProductQuantityChanger.vue';

const shopify = useShopify();
const model = defineModel();

defineProps({
  variant: {
    type: String,
    required: false,
  },
  available: {
    type: Boolean,
    required: true,
  },
  buyNow: {
    type: Boolean,
    default: true,
  },
  showOnMobile: {
    type: Boolean,
    default: true
  },
  showOnDesktop: {
    type: Boolean,
    default: true
  }
});

const addToCart = (variant, quantity) => {
  shopify.addToCart(variant, quantity)
    .then(() => {
      eventBus.$emit('cart-added-items');
    });
};

const fastCheckout = (variant, quantity) => {
  const windowRef = window.open('', '_blank');
  shopify.fastCheckout(variant, quantity)
    .then((checkoutUrl) => {
      if (checkoutUrl) {
        windowRef.location.href = checkoutUrl;
      }
    });
}
</script>

<template>
  <template v-if="available">
    <ProductQuantityChanger
      v-model="model"
      :limitMin="true"
      :showOnMobile="showOnMobile"
      :showOnDesktop="showOnDesktop"
    />
    <ButtonDefault type="colored" v-if="buyNow" @click="fastCheckout(variant, model)" class="cart-button">Jetzt kaufen</ButtonDefault>
    <ButtonDefault type="dark" v-if="variant" @click="addToCart(variant, model)" class="cart-button">In den Warenkorb</ButtonDefault>
  </template>
  <ButtonDefault type="white" disabled="true" v-else class="cart-button">Bald wieder verfügbar</ButtonDefault>
</template>

<style lang="scss" scoped>
.cart-button {
  height: 48px;
  font-weight: 600;

  &[disabled] {
    font-weight: 500;
    width: calc(100% - 40px);
    margin-inline: auto;
    border: 2px solid var(--clr-gray-200);
    background: var(--clr-white);
    color: var(--clr-gray-400);
  }
}
</style>